/**
 * The name of a conversation resumed from this phone, kept here too: a computer running an older Brocoded ignores the
 * title we send, and the chat would then show up as "New conversation".
 */
const TITLES_KEY = "brocoded.session-titles";

export function rememberedTitle(sessionId: string): string | undefined {
  try {
    return (JSON.parse(localStorage.getItem(TITLES_KEY) ?? "{}") as Record<string, string>)[sessionId];
  } catch {
    return undefined;
  }
}

export function rememberTitle(sessionId: string, title: string): void {
  try {
    const all = JSON.parse(localStorage.getItem(TITLES_KEY) ?? "{}") as Record<string, string>;
    const keep = Object.entries({ ...all, [sessionId]: title }).slice(-100); // the newest hundred is plenty
    localStorage.setItem(TITLES_KEY, JSON.stringify(Object.fromEntries(keep)));
  } catch {
    /* private mode: the name just won't be remembered */
  }
}
